import React from 'react'
import { Link } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import ArrowRightIcon from '../../assets/svg/arrow-right.inline.svg'

import * as styles from './recent.module.scss'

const RecentPost = props => {
    const { post, index } = props
    const image = post.featuredImage.node ? getImage(post.featuredImage.node.localFile) : null

    return (
        <div className={styles.post}>
            <article itemScope itemType='http://schema.org/Article'>
                <Link to={post.uri} itemProp='url'>
                    {post.featuredImage.node && (
                        <GatsbyImage
                            className={styles.postImage}
                            image={image}
                            alt={post.featuredImage.alt ? post.featuredImage.alt : 'Post Preview image'}
                        />
                    )}
                    <small className={styles.postDate}>{post.date}</small>
                    <h3 className={styles.postTitle} itemProp='headline'>
                        {post.title}
                    </h3>
                    <span className={styles.postTitleMore}>
                        <span>Подробнее</span>
                        <ArrowRightIcon />
                    </span>
                </Link>
            </article>
        </div>
    )
}

export default RecentPost
